// extracted by mini-css-extract-plugin
export var card = "CalloutCard-module--card--83758";
export var chevronButton = "CalloutCard-module--chevronButton--2807c";